import request from "@/utils/request";

export function getAllFreshSeedTransaction(params) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/GetAll",
        method: "GET",
        params
    });
}

export function getAllFreshSeedTransactionType() {
    return request({
        url: "/api/services/app/FreshSeedTransaction/GetAllTypesForDropDown",
        method: "GET"
    });
}

export function getFreshSeedTransactionDetail(params) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/Get",
        method: "GET",
        params
    });
}

export function createTransaction(data) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/Create",
        method: "POST",
        data
    });
}

export function createManyTransaction(data) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/CreateMany",
        method: "POST",
        data
    });
}

export function updateTransaction(data) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/Update",
        method: "PUT",
        data
    });
}

export function deleteTransaction(params) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/Delete",
        method: "DELETE",
        params
    });
}

export function deleteManyTransaction(data) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/DeleteMany",
        method: "POST",
        data
    });
}

export function getFilterInfo(params) {
    return request({
        url: "/api/services/app/FreshSeedTransaction/GetFilterInfo",
        method: "GET",
        params
    });
}





// WEBPACK FOOTER //
// ./src/api/fresh_seed_transaction.js